// authored by Joshua Beedle
import React from 'react';
import PropTypes from 'prop-types';

import Wrapper from './Wrapper';
import Text from './Text';

/**
  * @param {Node} children - The text passed down from the instantiated component
  * @param {Object} styledTextProps - Custom props for Text
  * @param {Object} styledWrapperProps - Custom props for wrapper
*/

const SubText = ({
  children,
  styledTextProps,
  styledWrapperProps,
}) => (
  <Wrapper
    {...styledWrapperProps}
  >
    <Text {...styledTextProps}>
      {children}
    </Text>
  </Wrapper>
);

SubText.propTypes = {
  children: PropTypes.node.isRequired,
  styledTextProps: PropTypes.instanceOf(Object),
  styledWrapperProps: PropTypes.instanceOf(Object),
};

SubText.defaultProps = {
  styledTextProps: {},
  styledWrapperProps: {},
};

export default SubText;
